import { ref } from 'vue';
import PromptTemplatesAPI from '@/api/promptTemplates';

export function usePromptTemplates() {
  const templates = ref([]);
  const currentTemplate = ref(null);
  const variables = ref([]);
  const versions = ref([]);

  const fetchAll = async () => {
    const response = await PromptTemplatesAPI.getAll();
    templates.value = response.prompt_templates || [];
  };

  const fetchOne = async (key) => {
    const response = await PromptTemplatesAPI.get(key);
    currentTemplate.value = response.prompt_template;
    variables.value = response.variables || [];
  };

  const save = async (key, systemPrompt, userPrompt) => {
    const response = await PromptTemplatesAPI.update(key, {
      system_prompt: systemPrompt,
      user_prompt: userPrompt
    });
    currentTemplate.value = response.prompt_template;
  };

  const fetchVersions = async (key) => {
    const response = await PromptTemplatesAPI.getVersions(key);
    versions.value = response.versions || [];
  };

  const restoreVersion = async (key, version) => {
    const response = await PromptTemplatesAPI.restore(key, version);
    currentTemplate.value = response.prompt_template;
  };

  const resetToDefault = async (key) => {
    const response = await PromptTemplatesAPI.resetToDefault(key);
    currentTemplate.value = response.prompt_template;
  };

  return {
    templates,
    currentTemplate,
    variables,
    versions,
    fetchAll,
    fetchOne,
    save,
    fetchVersions,
    restoreVersion,
    resetToDefault
  };
}
